// ============================================================================
// PRIM'S MST - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'prims',
  name: 'Prim\'s MST',
  category: 'Graphs',
  complexity: {
    time: 'O(E log V)',
    space: 'O(V)'
  },
  description: 'A minimum spanning tree algorithm that uses a greedy approach. It starts from an arbitrary vertex and repeatedly adds the cheapest edge that connects a vertex in the MST to a vertex outside it, using a priority queue.'
};
